import React from "react";
import cx from "classnames";
import ArticlePopover from "./articlePopover";
var NavArticles = function NavArticles(_ref) {
  var href = _ref.href,
    onClick = _ref.onClick,
    active = _ref.active,
    hotData = _ref.hotData,
    c = _ref.c,
    image = _ref.image,
    ga = _ref.ga,
    ga4 = _ref.ga4;
  return /*#__PURE__*/React.createElement("div", {
    id: 'newTopNav3',
    className: cx("tc-top-nav-item", {
      active: active === 2
    })
  }, /*#__PURE__*/React.createElement("a", {
    className: 'tc-top-nav-link',
    href: href,
    target: '_blank',
    onClick: onClick,
    rel: 'noreferrer'
  }, "\u6587\u7AE0"), /*#__PURE__*/React.createElement(ArticlePopover, {
    hotData: hotData,
    c: c,
    image: image,
    ga: ga,
    g4: ga4
  }));
};
export default NavArticles;